import shadowsocks from "./shadowsocks.json";
import ikev2 from "./ikev2.json";
import openvpn from "./openvpn.json";
import pptp from "./pptp.json";
import l2tp from "./l2tp.json";
import vless from "./vless.json";

export default { shadowsocks, ikev2, openvpn, pptp, l2tp, vless };
